module.exports = __webpack_public_path__ + "static/media/whatsappIcon.06bf48db.png";